import { call, put, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IJSResponse } from '../../../common/common.types'
import { GlobalOptionsService } from '../services/globalOptions.service'
import { GlobalDataConstants } from '../../globalData/store/globalData.constants'
import { SagaIterator } from 'redux-saga'
import * as actions from '../store/options.actions'

export function* setRulesUtilsModule(): SagaIterator {
  const globalOptionsService = new GlobalOptionsService()

  try {
    const rulesUtilsResponse: IJSResponse = yield call([globalOptionsService, globalOptionsService.getRulesUtils])
    const jsText = rulesUtilsResponse?.js

    if (jsText) {
      const exports = {}
      const module = { exports }
      const loadModule = new Function('exports', 'module', jsText)
      loadModule(exports, module)

      yield put(actions.setRulesUtilsModule(module.exports))
    }
  } catch (e) {
    yield put(throwPcrException(`setRulesUtilsModule() error: ${e}`))
  }
}
export function* setRulesUtilsModuleSaga() {
  yield takeLatest([GlobalDataConstants.ON_GLOBAL_DATA_IMPORT_SUCCESS], setRulesUtilsModule)
}
